export type SafetyTabs = BenefitTabs | MemberAssociationTabs;

export enum BenefitTabs {
  Warranty = "warrantyTab",
  UsedCarWarrantyPurchased = "usedCarWarrantyPurchasedTab",
  DeclarationOfGoods = "declarationOfGoodsTab",
  ServiceHistory = "serviceHistoryTab",
  ServicePlanFollowed = "servicePlanFollowedTab",
  ExchangePolicy = "exchangePolicyTab",
  Condition = "conditionTab",
  Premium = "premiumTab",
  HomeDelivery = "homeDeliveryTab",
}
export enum MemberAssociationTabs {
  TradeOrg = "tradeOrgTab",
  NbfMember = "nbfTab",
  MobilityPoolMember = "mobilityPoolTab",
  BruktbilgruppenMember = "bruktbilgruppenTab",
  NmcfMember = "nmcfTab",
  NcbMember = "ncbTab",
}
